export const homePortfolioSectionData = [
    {
        id: 1,
        title: "AI Tools – Multi-Tool AI Platform",
        skills: [
            "Next.js",
            "TypeScript",
            "Vercel AI SDK",
            "Google Gemini",
            "Cloudinary",
            "Tailwind CSS",
            "shadcn/ui",
            "AI Integration",
        ],
        description:
            "A modern AI-powered productivity platform offering AI tools for content creation, image editing, career assistance, and developer workflows. Features article writing, resume analysis, AI image generation, background/object removal, and multi-LLM provider support.",
        cardImage: require("../assets/images/projects/ai-tools.jpeg"),
        figma: "",
        isPrivate: true,
        liveUrl: "https://multi-ai-tools.netlify.app/",
        youtubeUrl: "",
    },
    {
        id: 3,
        title: 'Evibe E-commerce',
        skills: ["MERN Stack", "RTK Query", "Facebook Pixel", "Nodemailer", "Cloudinary", "TypeScript", "JavaScript",],
        description: 'Evibe an eCommerce platform tailored specifically for online shoe stores!',
        cardImage: require('../assets/images/projects/ecommarce-3.png'),
        figma: "",
        isPrivate: true,
        liveUrl: 'https://friend-shoes-ecommerce.netlify.app/',
        youtubeUrl: 'https://youtu.be/h2SX4VHQHlE',
    },
    {
        id: 2,
        title: 'Upcopo',
        skills: ["React Native", "Redux", "Redux Toolkit", "Native Base", "expo", "formik", "yup", "Google Map"],
        description: `NFTs app for Buy Virtual Real Estate.`,
        cardImage: require('../assets/images/projects/upocopo-2.png'),
        liveUrl: '',
        youtubeUrl: 'https://www.youtube.com/watch?v=k7098_rTLlA&feature=youtu.be',
        figma: "https://www.figma.com/file/xxFZjSHJXT2yrQwS68DCDm/Upcopo?node-id=412%3A712",
        githubUrl: '',
        isPrivate: true
    },

    // {
    //     id: 3,
    //     title: 'Positivus',
    //     skills: ["Node.js", "PostgressSQL", "pgAdmin4", "Cloudinary",
    //         "HTML", "CSS", "TypeScript", "NextJS", "pnpm", "Material UI", "Strapi Headless CMS", "Turborepo"],
    //     description: '🚀 Building a Scalable Fullstack Application with Turborepo 🚀',
    //     cardImage: require('../assets/images/projects/positivus.png'),
    //     figma: "https://www.figma.com/community/file/1230604708032389430/positivus-landing-page-design",
    //     // liveUrl: 'https://covid-19-survey-form-2020.netlify.app/',
    //     youtubeUrl: 'https://www.youtube.com/watch?v=gmtbP7m_Klw',
    //     githubUrl: "https://github.com/abdulkadershohan/positivus",
    //     isPrivate: false
    // },

]
export const homePortfolioPageData = [
    {
        id: 3,
        results: {
            title: 'web3 landing page',
            data: [
                {
                    id: 1,
                    title: 'Blockchain NFT website landing page',
                    skills: ["ReactJS", 'Figma to React', 'HTML', 'CSS', "JavaScript", "Material UI",],
                    description: 'Shihami is the world’s leading NFTs marketplace where you can discover, sell and bid NFTs and get rich.',
                    cardImage: require('../assets/images/projects/blockchaineNft.png'),
                    figma: "https://www.figma.com/community/file/1148947483588050590",
                    isPrivate: false,
                    liveUrl: 'https://blockchain-nft-website-landing-page.netlify.app/',
                    youtubeUrl: 'https://www.youtube.com/watch?v=5_GNOpPsIy0',
                    githubUrl: 'https://github.com/abdulkadershohan/Blockchain-NFT-Website-Landing-Page'
                },
                {
                    id: 2,
                    title: 'NFT Marketplace Landing page',
                    skills: ["ReactJS", 'Figma to React', 'HTML', 'CSS', "JavaScript", "Material UI",],
                    description: `The Leading NFT Marketplace On Ethereum Home To The Next Generation Of Digital Creators. Discover The Best NFT Collections.`,
                    cardImage: require('../assets/images/projects/nft2.png'),
                    figma: "https://www.figma.com/community/file/1131138961524331153",
                    isPrivate: false,
                    liveUrl: 'https://nft-marketplace-landing-page-1.netlify.app/',
                    youtubeUrl: 'https://youtu.be/uflKI9U8Q3Q',
                    githubUrl: 'https://github.com/abdulkadershohan/NFT-Marketplace-Landing-Page',

                },
                {
                    id: 3,
                    title: 'NFT Alien',
                    skills: ["ReactJS", 'Figma to React', 'HTML', 'CSS', "JavaScript", "Material UI",],
                    description: `A collection of 2525 highly-fashionable NFTs on the ETH Blockchain. Unique, metaverse-ready, and designed to benefit their holders.`,
                    cardImage: require('../assets/images/projects/nftAlien.png'),
                    isPrivate: false,
                    liveUrl: 'https://nft-alien-v2.netlify.app/',
                    youtubeUrl: '',
                    githubUrl: 'https://github.com/abdulkadershohan/nft-alien',
                    figma: 'https://www.figma.com/community/file/1177468786531815516'
                },
            ]
        },
    },
    {
        id: 2,
        results: {
            title: 'web 2.0 projects',
            data: [
                {
                    id: 11,
                    title: "AI Tools – Multi-Tool AI Platform",
                    skills: [
                        "Next.js",
                        "TypeScript",
                        "Vercel AI SDK",
                        "Google Gemini",
                        "Cloudinary",
                        "Tailwind CSS",
                        "shadcn/ui",
                        "AI Integration",
                    ],
                    description:
                        "A modern AI-powered productivity platform offering AI tools for content creation, image editing, career assistance, and developer workflows. Features article writing, resume analysis, AI image generation, background/object removal, and multi-LLM provider support.",
                    cardImage: require("../assets/images/projects/ai-tools.jpeg"),
                    figma: "",
                    isPrivate: true,
                    liveUrl: "https://multi-ai-tools.netlify.app/",
                    youtubeUrl: "",
                },
                {
                    id: 10,
                    title: 'Flat River Admin Dashboard',
                    skills: ["TypeScript", "Mantine", "Tailwind CSS", "React JS", "Redux & Redux Toolkit", "zod", "tanstack/react-router"],
                    description: 'Flat River Admin Dashboard is a modern, clean, and very detailed admin dashboard template for web developers and business owners.',
                    cardImage: require('../assets/images/projects/flat-river.png'),
                    figma: "https://www.figma.com/design/I1P5lySWXKDNXq23Gl47RX/flatriver-(Admin)-Phase-1?node-id=353-8746&m=dev",
                    isPrivate: true,
                    liveUrl: 'https://flat-river.vercel.app/',
                    youtubeUrl: '',
                },
                {
                    id: 9,
                    title: 'Evibe E-commerce',
                    skills: ["MERN Stack", "RTK Query", "Facebook Pixel", "Nodemailer", "Cloudinary", "TypeScript", "JavaScript",],
                    description: 'Evibe an eCommerce platform tailored specifically for online shoe stores!',
                    cardImage: require('../assets/images/projects/ecommarce-3.png'),
                    figma: "",
                    isPrivate: true,
                    liveUrl: 'https://friend-shoes-ecommerce.netlify.app/',
                    youtubeUrl: 'https://youtu.be/h2SX4VHQHlE',
                },
                {
                    id: 8,
                    title: 'Positivus',
                    skills: ["Node.js", "PostgressSQL", "pgAdmin4", "Cloudinary",
                        "HTML", "CSS", "TypeScript", "NextJS", "pnpm", "Material UI", "Strapi Headless CMS", "Turborepo"],
                    description: '🚀 Building a Scalable Fullstack Application with Turborepo 🚀',
                    cardImage: require('../assets/images/projects/positivus.png'),
                    figma: "https://www.figma.com/community/file/1230604708032389430/positivus-landing-page-design",
                    // liveUrl: 'https://covid-19-survey-form-2020.netlify.app/',
                    youtubeUrl: 'https://www.youtube.com/watch?v=gmtbP7m_Klw',
                    githubUrl: "https://github.com/abdulkadershohan/positivus",
                    isPrivate: false
                },
                {
                    id: 7,
                    title: 'Vitlous',
                    skills: ["ReactJS", "RestAPi", "JavaScript", "Material UI", "RTK Query ", "Micro Service", "WebSocket",],
                    description: 'Vitlous is an all-in-one online project management software that can streamline your construction projects, enhance efficiency, and keep everyone on track. It is highly rated in its field.',
                    cardImage: require('../assets/images/projects/rbs.png'),
                    figma: "",
                    isPrivate: true,
                    liveUrl: 'https://vitlous.com/',
                    // youtubeUrl: 'https://www.youtube.com/watch?v=0KnPfVyOxeg&t=5s',
                },
                {
                    id: 1,
                    title: 'Covid-19 Survey',
                    skills: ["ReactJS", "HTML", "CSS", "JavaScript", "Bootstrap", "EmailJS", "Styled Component",
                        "PHP", "MYSQL"],
                    description: 'Helth Care App',
                    cardImage: require('../assets/images/projects/covid-19.png'),
                    figma: "",
                    isPrivate: false,
                    liveUrl: 'https://covid-19-survey-form-2020.netlify.app/',
                    // youtubeUrl: 'https://www.youtube.com/watch?v=0KnPfVyOxeg&t=5s',
                    githubUrl: "https://github.com/abdulkadershohan/COVID-19-SURVEY-FROM"
                },
                {
                    id: 2,
                    title: 'Covid-19 Live Status',
                    skills: ["ReactJS",
                        "HTML", "CSS", "Bootstrap", "JavaScript", "Axios"],
                    description: `Worldometer Api`,
                    cardImage: require('../assets/images/projects/LiveStatus.png'),
                    liveUrl: 'https://covit-19-live-states.netlify.app/',
                    // youtubeUrl: 'https://www.youtube.com/watch?v=k7098_rTLlA&feature=youtu.be',
                    // figma: "https://www.figma.com/file/xxFZjSHJXT2yrQwS68DCDm/Upcopo?node-id=412%3A712",
                    githubUrl: 'https://github.com/abdulkadershohan/covit-19-live-states',
                    isPrivate: false
                },
                {
                    id: 3,
                    title: 'Gym Website',
                    skills: ["ReactJS",
                        "HTML", "CSS", "JavaScript"],
                    description: 'Gym Landing Page',
                    cardImage: require('../assets/images/projects/gym2.png'),
                    isPrivate: false,
                    liveUrl: 'https://gym-website-9.netlify.app/',
                    // figma: "https://www.figma.com/file/HPX2Q9k7QC0jughEcor3Ad/Bai1234?fuid=1020350840147497557",
                    youtubeUrl: '',
                    githubUrl: 'https://github.com/abdulkadershohan/gym-website'

                },
                {
                    id: 4,
                    title: 'Food Website',
                    skills: ["ReactJS",
                        "HTML", "CSS", "JavaScript"],
                    description: 'Restaurant Landing Page',
                    cardImage: require('../assets/images/projects/food2.png'),
                    isPrivate: false,
                    liveUrl: 'https://restaurant-website-9.netlify.app/',
                    // figma: "https://www.figma.com/file/HPX2Q9k7QC0jughEcor3Ad/Bai1234?fuid=1020350840147497557",
                    youtubeUrl: '',
                    githubUrl: 'https://github.com/abdulkadershohan/restaurant-website'

                },
                {
                    id: 5,
                    title: 'Food Website',
                    skills: ["ReactJS",
                        "HTML", "Styled Component",
                        "JavaScript"],
                    description: 'E-commerce food app',
                    cardImage: require('../assets/images/projects/food2.png'),
                    isPrivate: false,
                    liveUrl: 'https://ecommerce-restaurant.netlify.app/',
                    // figma: "https://www.figma.com/file/HPX2Q9k7QC0jughEcor3Ad/Bai1234?fuid=1020350840147497557",
                    youtubeUrl: '',
                    githubUrl: 'https://github.com/abdulkadershohan/ecommerce-restaurant'

                },
                {
                    id: 6,
                    title: 'Video Chat App',
                    skills: ["ReactJS",
                        "HTML", "CSS", "Socket.io", "express", "node.js",
                        "JavaScript"],
                    isPrivate: false,
                    description: 'WebRTC Video Chat App',
                    cardImage: require('../assets/images/projects/rtc.png'),
                    liveUrl: 'https://video-chat-zoom-clone.netlify.app/',
                    // figma: "https://www.figma.com/file/HPX2Q9k7QC0jughEcor3Ad/Bai1234?fuid=1020350840147497557",
                    youtubeUrl: '',
                    githubUrl: 'https://github.com/abdulkadershohan/web-rtc-video-chat-zoom-clone'

                },

            ],
        }
    },
    {
        id: 1,
        results: {
            title: 'android & IOS apps',
            data: [
                {
                    id: 1,
                    title: 'Upcopo',
                    skills: ["React Native", "Redux", "Redux Toolkit", "Native Base", "expo", "formik", "yup", "Google Map"],
                    description: `NFTs app for Buy Virtual Real Estate.`,
                    cardImage: require('../assets/images/projects/upocopo-2.png'),
                    liveUrl: '',
                    youtubeUrl: 'https://www.youtube.com/watch?v=k7098_rTLlA&feature=youtu.be',
                    figma: "https://www.figma.com/file/xxFZjSHJXT2yrQwS68DCDm/Upcopo?node-id=412%3A712",
                    githubUrl: '',
                    isPrivate: true
                },
                {
                    id: 2,
                    title: 'Brdcart',
                    skills: ["React Native", "Redux", "Redux Toolkit", "Native Base", "expo", "formik", "yup", "Google Map"],
                    description: 'E-commerce app',
                    cardImage: require('../assets/images/projects/brdchart.png'),
                    liveUrl: '',
                    figma: "https://www.figma.com/file/HPX2Q9k7QC0jughEcor3Ad/Bai1234?fuid=1020350840147497557",
                    youtubeUrl: '',
                    githubUrl: '',
                    isPrivate: true

                },
                {
                    id: 3,
                    title: 'UIUX_Learning_App',
                    skills: ["React Native", "Redux", "Redux Toolkit", "Native Base", "expo", "formik", "yup",],
                    description: 'Learning App',
                    cardImage: require('../assets/images/projects/learningapp.png'),
                    figma: "https://www.figma.com/file/G8IR3mlAuzpsykfRF7g5tU/UXchips_UIUX_Learning_App?t=ccx99V0x6MlRyjjj-0",
                    // liveUrl: 'https://covid-19-survey-form-2020.netlify.app/',
                    // youtubeUrl: 'https://www.youtube.com/watch?v=0KnPfVyOxeg&t=5s',
                    // githubUrl: "https://github.com/abdulkadershohan/COVID-19-SURVEY-FROM"
                    isPrivate: true
                },
                {
                    id: 4,
                    title: 'SeRemo',
                    skills: ["React Native", "Redux", "Redux Toolkit", "Native Base", "expo", "formik", "yup",],
                    description: 'Business app',

                    cardImage: require('../assets/images/projects/SeRemo2.png'),
                    figma: "https://www.figma.com/file/xgeqbCe4AZMHuBE9q3ogNA/izackmbimi?node-id=440%3A614&t=yE99K0IDkJbE9StL-0",
                    // liveUrl: 'https://covid-19-survey-form-2020.netlify.app/',
                    // youtubeUrl: 'https://www.youtube.com/watch?v=0KnPfVyOxeg&t=5s',
                    // githubUrl: "https://github.com/abdulkadershohan/COVID-19-SURVEY-FROM"
                    isPrivate: true
                },
                {
                    id: 5,
                    title: 'RBS Movie App',
                    skills: ["React Native", "Native Base", "expo", "formik", "yup",],
                    description: 'OTT app',
                    isPrivate: true,
                    cardImage: require('../assets/images/projects/ott.png'),
                    figma: "https://www.figma.com/file/xgeqbCe4AZMHuBE9q3ogNA/izackmbimi?node-id=440%3A614&t=yE99K0IDkJbE9StL-0",
                    // liveUrl: 'https://covid-19-survey-form-2020.netlify.app/',
                    // youtubeUrl: 'https://www.youtube.com/watch?v=0KnPfVyOxeg&t=5s',
                    // githubUrl: "https://github.com/abdulkadershohan/COVID-19-SURVEY-FROM"
                },
                {
                    id: 6,
                    title: 'Covid-19 Survey App',
                    skills: ["React Native", "Native Base", "Axios", "PHP", "MYSQL"],
                    description: 'Helth Care App',
                    cardImage: require('../assets/images/projects/covidapp.jpg'),
                    figma: "",
                    // liveUrl: 'https://covid-19-survey-form-2020.netlify.app/',
                    youtubeUrl: 'https://www.youtube.com/watch?v=MGYeFVJtlQc',
                    githubUrl: "https://github.com/abdulkadershohan/covid_19_survey_app",
                    isPrivate: false
                },
            ],
        },

    },
]